/**
 * Zama対応版: lat/lng がない避難所のみ Google Geocoder で補完する
 * - 既存の lat/lng 付きデータはそのまま使う
 * - 座間市 JSON は初回表示時に geocode
 */
(function() {
  'use strict';

  const geocodeAddress = (geocoder, shelter) => {
    return new Promise((resolve) => {
      const query = `${shelter.name} ${shelter.address}`;
      geocoder.geocode({ address: query }, (results, status) => {
        if (status === 'OK' && results && results[0]) {
          resolve({
            ...shelter,
            lat: results[0].geometry.location.lat(),
            lng: results[0].geometry.location.lng()
          });
          return;
        }

        console.warn(`[Yam-G Alert] Geocoding失敗: ${shelter.name} / ${status}`);
        resolve(shelter);
      });
    });
  };

  const initShelterMap = async () => {
    const mapEl = document.getElementById('shelter-map');
    if (!mapEl || typeof google === 'undefined' || !google.maps) return;
    if (mapEl.classList.contains('is-initialized')) return;

    let shelterData = JSON.parse(mapEl.dataset.shelters || '[]');
    const geocoder = new google.maps.Geocoder();

    for (let i = 0; i < shelterData.length; i++) {
      if (!shelterData[i].lat || !shelterData[i].lng) {
        shelterData[i] = await geocodeAddress(geocoder, shelterData[i]);
        await new Promise(r => setTimeout(r, 120));
      }
    }

    mapEl.dataset.shelters = JSON.stringify(shelterData);

    const infoWindow = new google.maps.InfoWindow();
    const markers = [];
    const bounds = new google.maps.LatLngBounds();
    const map = new google.maps.Map(mapEl, {
      zoom: 14,
      center: { lat: 35.4875, lng: 139.4077 },
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false
    });

    shelterData.forEach((s, i) => {
      if (s.lat && s.lng) {
        const pos = { lat: parseFloat(s.lat), lng: parseFloat(s.lng) };
        const marker = new google.maps.Marker({
          map,
          position: pos,
          title: s.name,
          animation: google.maps.Animation.DROP
        });

        markers[i] = marker;
        bounds.extend(pos);

        marker.addListener('click', () => {
          infoWindow.setContent(`
            <div class="padding-box-s">
              <strong class="c-main">${s.name}</strong><br>
              <small>${s.address}</small><br>
              ${s.category ? `<small>${s.category}</small>` : ''}
            </div>
          `);
          infoWindow.open(map, marker);
        });
      }
    });

    if (markers.length > 0) map.fitBounds(bounds);

    mapEl.classList.add('is-initialized');
    const loader = mapEl.querySelector('.map-loader');
    if (loader) loader.style.display = 'none';

    window.focusShelterMarker = (index) => {
      const marker = markers[index];
      if (marker) {
        map.panTo(marker.getPosition());
        map.setZoom(16);
        google.maps.event.trigger(marker, 'click');
      }
    };
  };

  window.handleShelterClick = function(index) {
    if (typeof window.focusShelterMarker === 'function') {
      window.focusShelterMarker(index);
    }
    const mapElement = document.getElementById('shelter-map');
    if (mapElement && (window.innerWidth <= 768 || mapElement.getBoundingClientRect().top < 0)) {
      mapElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const pollGoogleMaps = setInterval(() => {
          if (typeof google !== 'undefined' && typeof google.maps !== 'undefined') {
            clearInterval(pollGoogleMaps);
            initShelterMap();
          }
        }, 200);
        obs.unobserve(entry.target);
      }
    });
  }, {
    rootMargin: '100px 0px',
    threshold: 0
  });

  document.addEventListener('DOMContentLoaded', () => {
    const mapContainer = document.getElementById('shelter-map');
    if (mapContainer) observer.observe(mapContainer);
  });
})();
